// sensei-app/client/ui/AdminPlatformDashboard.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class CAdminDashboard extends ComponentBase {
    constructor(config) {
        super(config);
        this.dashboardComponent = null;
    }

    async initialize() {
        await super.initialize();
        this.dashboardComponent = await this.createManagedComponent('Dashboard', null, {
            instanceId: `${this.config.instanceId}-cadmin-dashboard`,
            role:'courseAdmin'
        });
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'dashboard-container';
        }
        this.container.innerHTML = ''; 
        const dashboardElement = await this.dashboardComponent.render();
        this.container.appendChild(dashboardElement);
        
        this.appClient.tx.applyTranslations(this.container);
        return this.container;
    }
}